/**************************************************
 * Nombre:       Seccion_Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Pagina from "../Formularios/Formulario_Pagina";
import {usuarioContext} from "../../App";
import Pagina_Personal from "./Componentes/SubComponentes/Pagina_Personal";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {useCopiarPortapapeles} from "../../Utilidades/useCopiarPortapapeles";


const Seccion_Pagina = () => {
    const {sCell} = useResponsive()
    const cData = useContext(usuarioContext)
    const {AvisoPortapapeles, copiarPortapapeles} = useCopiarPortapapeles()
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const [cargando, setCargando] = useState(false)
    const [datos, setDatos] = useState({})


    const guardarDatos = async () => {

        let entidad = await obtenerEntidad()
        setCargando(true)
        entidad.id = cData.usuario.id
        let doxImg = await subirImagenHostingFile(entidad.img)
        entidad.img = doxImg.data
        let dox = await guardarDoc('paginas', entidad)
        setDatos(entidad)
        setCargando(false)
    }

    useEffect(() => {


        obtenerDoc('paginas', cData.usuario.id).then((dox) => {

            if (dox.res && dox.data) {
                setEntidad(dox.data)
                setDatos(dox.data)
            } else {
                let usuario = cData.usuario
                props.setValue('nombre', usuario.nombre)
                props.setValue('img', usuario.img)
            }
        })


    }, [cData]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}

            >

                <AvisoPortapapeles/>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>
                                        Pagina Personal
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 1}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        Crea tu propia página de presentación con los enlaces a tus redes y comparte tu
                                        perfil profesional con el mundo desde un solo lugar.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Formulario_Pagina props={props}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                                    <Button onClick={() => guardarDatos()}
                                            loading={cargando}
                                    >Actualizar</Button>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Pagina_Personal item={datos}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Button onClick={() => copiarPortapapeles(`https://sistemateamtufino.com/Pagina/${datos.id}`)}>Copiar enlace de la pagina</Button>
                                </Grid>

                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}}
                      sx={{justifyContent: 'flex-start', mt: 8, px: sCell ? 0 : 4}}>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Pagina


